/**
 * Document verification types — extracted subset of
 * apps/auction/src/features/clients/types/user.ts used by the admin page.
 */

export enum DocumentVerificationStatus {
  PENDING = 'pending',
  VERIFIED = 'verified',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
}

export type DocumentsFilter = 'all' | 'pending' | 'verified' | 'rejected';

export interface UserDocument {
  _id?: string;
  userId: string;
  documentType: string;
  documentNumber: string;
  firstName: string;
  lastName: string;
  fileName?: string;
  fileSize?: number;
  fileUrl?: string;
  uploadedAt?: string;
  verificationStatus?: DocumentVerificationStatus;
  verifiedAt?: string;
  verifiedBy?: string;
  rejectionReason?: string;
}

export interface DocumentWithUser extends UserDocument {
  user?: {
    firstName: string;
    lastName: string;
    email: string;
  } | null;
}
